import { action } from '@reatom/framework'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { reatomRequest } from '@root/shared/lib'
import { showErrorSnackbarAction } from '@root/shared/ui'
import { confirmAction } from '@root/shared/ui/confirm-dialog'
import { showSnackbarAction } from '@root/shared/ui-kit'

import { reatomBackOfficeCommentDeleteRequestAction } from './reatom-back-office-comment-delete-request-action'

import type { CommentId } from '@root/entities/comment/model/comment-id'

interface BackOfficeCommentDeleteModelOptions {
  commentId: CommentId
  onDone: (commentId: CommentId) => void
}

export const reatomBackOfficeCommentDeleteModel = (
  options: BackOfficeCommentDeleteModelOptions,
) => {
  // eslint-disable-next-line @reatom/unit-naming-rule
  const model = reatomRequest({
    // eslint-disable-next-line @reatom/unit-naming-rule
    execAction: action((ctx) =>
      // eslint-disable-next-line @reatom/unit-naming-rule
      reatomBackOfficeCommentDeleteRequestAction(ctx, options),
    ),
  })

  const deleteWithConfirmationAction = action(async (ctx) => {
    const confirmResult = await ctx.schedule(() =>
      confirmAction(ctx, {
        describedBy: i18next.t('comment.delete.confirmation.title'),
        title: i18next.t('comment.delete.confirmation.title'),
        description: i18next.t('comment.delete.confirmation.description'),
      }),
    )

    if (Result.isFailure(confirmResult)) {
      return
    }

    const deleteResult = await ctx.schedule(() => model.execute(ctx))

    Result.match(deleteResult, {
      onFailure: (error) => showErrorSnackbarAction(ctx, error),
      onSuccess: ({ success }) => {
        if (success) {
          showSnackbarAction(ctx, {
            text: i18next.t('comment.comment_deleted'),
            intent: 'success',
          })
          options.onDone(options.commentId)
        } else {
          showSnackbarAction(ctx, {
            text: i18next.t('common.something-went-wrong'),
            intent: 'error',
          })
        }
      },
    })
  }, 'deleteWithConfirmationAction')

  return { model, deleteWithConfirmationAction }
}
